module.exports = __webpack_public_path__ + "static/pcracinglogo-f3d33fe9e00c6d65989047a07349cc4f.png";